import React from 'react';
import Grid from '@material-ui/core/Grid';

var Center = function Center(_ref) {
  var children = _ref.children;
  return React.createElement(Grid, {
    container: true,
    direction: "column",
    alignItems: "center",
    justify: "center",
    style: {
      height: '100%',
      textAlign: 'center'
    }
  }, React.createElement(Grid, {
    item: true
  }, children));
};

export default Center;